// format number to Indian rupee
let rupee = new Intl.NumberFormat('en-IN', {
  style: 'currency',
  currency: 'INR',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
})

const formatToINR = (value) => {
  if (!value || value === '' || isNaN(value)) {
    return '---'
  } else {
    return rupee.format(value)
  }
}

export default formatToINR

export const formatToShortHandNotation = (value) => {
  let val = Math.abs(value)
  if (!isNaN(val)) {
    if (val >= 10000000) {
      val = formatToINR((val / 10000000).toFixed(1)) + ' Cr'
    } else if (val >= 100000) {
      val = formatToINR((val / 100000).toFixed(1)) + ' L'
    } else if (val >= 1000) {
      val = formatToINR(Math.round(val / 1000)) + ' K'
    }
    return val
  }
  return '---'
}
